<template>
  <div v-if="show" class="basic-block block-banner" :style="styles">
    <template v-if="campaign === 'LINE'">
      <span class="additinal-caption" v-if="caption"><span class="wrap" v-html="caption"></span></span>
      <span class="additinal-caption" v-else-if="hasCaption"><span class="wrap">今ならなんと、LINE登録で<br>{{counselorName}}の占いが１つ無料に！</span></span>
      <a href="/lp/campaign/1" @click.prevent="onBannerClick">
        <img :src="`${lineBannerImage}`" alt="LINE公式アカウント友達追加キャンペーン" width="320">
      </a>
    </template>
    <div class="banner-wrap" v-else-if="campaign === 'yearluck'">
      <a href="/2022_luck" @click.prevent="onBannerClick">
        <img src="https://uranaitv-town-dev.s3-ap-northeast-1.amazonaws.com/banner/yearluck2022.png" alt="2022年の運勢">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockBanner',
  props: {
    bannerPos: {
      type: String,
      default: '',
    },
    gaEventCateg: {
      type: String,
      default: 'LINE-campaign-banner'
    },
    lpId: {
      type: Number,
      default: 0
    },
    campaign: {
      type: String,
      default: '___LINE',
    },
    caption: String,
    hasCaption: {
      type: Boolean,
      default: false,
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return null
      }
    },
  },
  data() {
    return {
      // 親コンポーネントでも showBanner で表示・非表示を変えられるけど、
      // ここだと一括で切り替えられるので、応急処置用
      show: true,
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : '#142254',
      }
    },
    img(){
      switch(this.lpId){
        case 1: return 'kurenotori'
        case 2: return 'kanoucoco'
        case 3: return 'touwa'
        case 4: return 'houen'
        default: return '202111'
      }
    },
    lineBannerImage(){
      const def = '/static/img/recommend/lp/banner/20220217_line.png'
      const rtn = !!this.targetInfo && !!this.targetInfo.lineBanner ? this.targetInfo.lineBanner.bannerUrl : def
      console.log('imagepath[%s]', rtn)
      return rtn
    },
    counselorName(){
      return !!this.targetInfo ? this.targetInfo.name : '暮れの酉'
    }
  },
  methods: {
    onBannerClick(e){
      let param = {
        'event_category': this.gaEventCateg,
      }
      if (this.bannerPos) {
        param.event_label = this.bannerPos
      }
      window.gtag('event', 'click', param)
      location.href = this.$handoverParams(e.target.href)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);

.block-banner {
  padding: 24px 0 48px;
  text-align: center;
  background: #fff;
  a{
    pointer-events: auto;
    display: inline-block;
    img {
      max-width: 100%;
      vertical-align: middle;
      pointer-events: none;
    }
  }
  .banner-wrap {
    padding: 0 20px;
  }
  .additinal-caption {
    width: 100%;
    color: $l_col_keycolor;
    font-weight: bold;
    display: block;
    margin-bottom: 8px;

    font-size: 14px;
    line-height: 22px;
    @include mq('w320'){
      font-size: 16px;
      line-height: 24px;
    }

    .wrap {
      display: inline-block;
      min-width: 220px;
    }
    &::before,
    &::after{
      content: "";
      width: 40px;
      box-sizing: border-box;
      display: inline-block;
      background: $l_col_keycolor;
      border-bottom: 1px solid $l_col_keycolor;
      height: 2px;
      border-radius: 2px;
      vertical-align: bottom;
      @include mq('w320'){
        width: 42px;
      }
    }
    &::before {
      transform: translate(-14px,-4px) rotate(66deg);
      transform-origin: right bottom;
    }
    &::after {
      transform: translate(9px,-4px) rotate(-66deg);
      transform-origin: left bottom;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockBanner.vue